import React, { useState } from 'react';
import styles from './reservationSelector.module.css';
import Slider from '../Common/Slider/Slider';

const PaxSelector = ({ handleChangePax, defaultPax }) => {
  const pax = [...Array(20).keys()].map((i) => i + 1);
  pax.push(21);
  const [selectedPax, setSelectedPax] = useState(defaultPax);

  const onChangePax = (value) => {
    if (value > 0) {
      setSelectedPax(value);
      if (handleChangePax) handleChangePax(value);
    }
  };

  return (
    <>
      {selectedPax > 20 ? (
        <div className={`fade-up d-flex justify-content-start align-items-center mt-2 py-1`}>
          <div className={styles.paxHandle} onClick={() => onChangePax(selectedPax - 1)}>
            -
          </div>
          <input
            type='number'
            value={selectedPax}
            readOnly
            className={`${styles.customPax} bold text-center`}
          />
          <div className={styles.paxHandle} onClick={() => onChangePax(selectedPax + 1)}>
            +
          </div>
        </div>
      ) : (
        <Slider slideSpacing={10} touchScroll={true} showBtns={false} visibleSlides={'all'}>
          {pax.map((pax, index) => (
            <div
              key={index}
              className={`${styles.paxContainer} ${
                selectedPax === pax ? styles.paxSelected : ''
              } text-center`}
              onClick={() => onChangePax(pax)}
            >
              {pax === 21 ? '+20' : pax}
            </div>
          ))}
        </Slider>
      )}
    </>
  );
};

export default PaxSelector;
